import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randProductName } from '@ngneat/falso'
import type { SchemaAttributes } from '../../types.js'

type ConsultationItemTemplateAttributes =
  SchemaAttributes<'ConsultationItemTemplate'>

export const model = (
  Model as ModelDefinition<ConsultationItemTemplateAttributes>
).extend({})

export const factory = Factory.extend<ConsultationItemTemplateAttributes>({
  name() {
    return randProductName()
  },
})
